import * as React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FormHelperText, Grid, InputLabel, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { el } from "react-date-range/src/locale/index";

function FormDatePicker(props) {
  const { label, name, formik, ...rest } = props;

  const [value, setValue] = React.useState(null);

  return (
    <Grid>
      <Box
        sx={{
          width: "100%",
          borderLeft: formik.errors[name] ? "4px solid #ca2e2e" : "",
          paddingLeft: formik.errors[name] ? "16px" : "",
        }}
      >
        <InputLabel
          htmlFor={name}
          sx={{
            textAlign: "left",
            textStyle: "none",
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: "500" }}>
            {label}
          </Typography>
        </InputLabel>

        <LocalizationProvider locale={el} dateAdapter={AdapterDateFns}>
          <DatePicker
            label={null}
            inputFormat="dd/MM/yyyy"
            value={
              value
                ? value
                : formik.getFieldProps(`${name}`).value
                  ? formik.getFieldProps(`${name}`).value
                  : null
            }
            forma
            onChange={(newValue) => {
              setValue(newValue);
              formik.setFieldValue(`${name}`, newValue);
            }}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                sx={{ width: "100%" }}
                {...params}
                inputProps={{
                  ...params.inputProps,
                  placeholder: "ηη/μμ/χχχχ",
                }}
              />
            )}
            {...rest}
          />
        </LocalizationProvider>
        <FormHelperText error>
          <Typography
            variant="body1"
            sx={{
              marginTop: "16px",
              fontWeight: "bolder",
            }}
          >
            {formik.errors[name]}
          </Typography>
        </FormHelperText>
      </Box>
    </Grid>
  );
}

export default FormDatePicker;
